import { render, staticRenderFns } from "./opsAdmin.vue?vue&type=template&id=f3d795ca"
import script from "./opsAdmin.vue?vue&type=script&lang=js"
export * from "./opsAdmin.vue?vue&type=script&lang=js"
import style0 from "./opsAdmin.vue?vue&type=style&index=0&id=f3d795ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports